import { initialState } from "../utils/stateUtils";
import store from "./index";

export const UPDATE_COMPONENTS = (state, components) => {
  state.components = components;
};

export const UPDATE_FONTS = (state, fonts) => {
  state.fonts = Object.freeze(fonts);
};


export const UPDATE_TEMPLATES = (state, templates) => {
  state.templates = templates;
};

export const ADD_FRAME = (state, { frame, index }) => {
  frame = Object.freeze(frame);
  state.frames.splice(index, 0, frame);
};

export const DELETE_FRAME = (state, index) => {
  state.frames.splice(index, 1);
};

export const SWAP_FRAMES = (state, { firstIndex, secondIndex }) => {
  let temp = state.frames[firstIndex];
  state.frames[firstIndex] = state.frames[secondIndex];
  state.frames.secondIndex = temp;
};

export const DELETE_EVENT = (state, index) => {
  state.events.triggers.splice(index, 1);
};

export const DELETE_EVENT_ID = (state, id) => {
  let index = state.events.triggers.findIndex(e => e.eventId == id)
  state.events.triggers.splice(index, 1);
};

export const DELETE_CUSTOM_METHOD = (state, name) => {
  delete state.events.methods[name];
};

export const SET_FRAMES = (state, frames) => {
  state.frames = frames;
};
export const SET_EVENTS = (state, events) => {
  let methods = events.methods;
  state.events = events;
  try {
    // check methods is not a empty array or empty object
    if (methods && Object.keys(methods).length == 0) {
      state.events.methods = {};
    }
  } catch (e) {
    console.log(e);
  }

};
export const SET_TAGS = (state, tags) => {
  state.tags = tags;
};

export const SET_IS_DRAFT_SAVED = (state, isSaved) => {
  state.isDraftSaved = isSaved;
};

export const SET_IS_PREVIEW = (state, isPreview) => {
  state.isPreview = isPreview;
};

export const SET_THUMBNAIL_URL = (state, url) => {
  state.thumbnailUrl = url;
};

export const SET_TEMPLATE_CACHE = (state, data) => {
  state.templateCache = data;
};


export const SAVE_CREATIVE_STATUS = (state, show) => {
  state.saveCreativeStatus = show;
};
export const PUBLISHED_PREVIEW_ID = (state, previewId) => {
  state.publishedPreviewId = previewId;
};
export const DRAFT_PREVIEW_ID = (state, previewId) => {
  state.draftPreviewId = previewId;
};
export const SAVE_DRAFT_UPDATED_DATE = (state, draftUpdated) => {
  state.draftUpdatedDate = draftUpdated;
};
export const SET_CREATIVE_NAME = (state, creativeName) => {
  state.activeCreativeName = creativeName;
};

export const SET_CREATIVE_ID = (state, creativeId) => {
  state.activeCreativeId = creativeId;
};

export const LOAD_FONTS = (state, loadedFont) => {
  state.loadedFonts.add(loadedFont);
};

export const ADD_ANIMATION_TIMING = (state, animationTiming) => {
  //state.animationTimings.push(animationTiming);
  state.animationTimings = animationTiming;
};

export const SET_ANIMATION_TIMING = (state, animationTiming) => {
  state.animationTimings = animationTiming;
};

export const UPDATE_CURRENT_FRAME = (state, currentFrame) => {
  state.currentFrame = currentFrame;
};

export const UPDATE_FRAME_PREVIEW = (state, { frameId, src, frame }) => {
  if (frameId < 0) {
    return;
  }
  const temp = { ...state.frames[frameId] };
  temp.src = src;
  temp.state = frame;
  temp.state.id = state.frames[frameId]?.id || frame.id;
  state.frames[frameId] = Object.freeze(temp);
};

export const UPDATE_FRAME_NAME = (state, { frameId, name }) => {
  if (frameId < 0) {
    return;
  }
  const temp = { ...state.frames[frameId] };
  temp.name = name;
  state.frames[frameId] = Object.freeze(temp);
};

export const UPDATE_FRAME_SIZE = (state, { frameId, size }) => {
  if (frameId < 0) {
    return;
  }
  const temp = { ...state.frames[frameId] };
  temp.width = size.width;
  temp.height = size.height;
  state.frames[frameId] = Object.freeze(temp);
};

export const SET_OUTLINE = (state, objects) => {
  state.outliner = objects;
};

export const ADD_TRIGGER = (state, data) => {
  let trigger = data.event;
  trigger.pageSelected = data.pageId;
  state.events.triggers.push(trigger);
};

export const EDIT_TRIGGER = (state, { trigger, pageId, index }) => {
  trigger.pageSelected = pageId;
  state.events.triggers[index] = trigger;
};

export const ADD_CUSTOM_METHOD = (state, { name, body }) => {
  state.events.methods[name] = body;
};

export const SET_CURRENT_CONTEXT = (state, payload) => {
  state.currentUser = payload.user;
  state.currentTenant = payload.tenant;
  state.childTenants = payload.childTenants || [];
}
export const SET_CREATIVES_LIST = (state, creatives) => {
  state.creatives = creatives;
};
export const LOGOUT_USER = () => {
  store.replaceState(initialState());
};

export const SET_READONLY = (state, readonly) => {
  state.readonly = readonly;
};

export const SET_CREATIVE_VERSION = (state, index) => {
  state.activeCreativeVersion = index;
};

export const ADD_TIMELINE_EVENT = (state, frame) => {
  state.events.timelineEvents = frame;
}

export const DELETE_TIMELINE_EVENT = (state, index) => {
  state.events.timelineEvents.splice(index, 1);
}

export const ADD_TIMED_EVENT = (state, { componentId, timedEvent }) => {
  state.timedEvents[componentId] = timedEvent;
}

export const DELETE_TIMED_EVENT = (state, componentId) => {
  delete state.timedEvents.componentId;
}

export const SET_TIMED_EVENT = (state, data) => {
  state.timedEvents = data;
}
export const SET_COMPONENT_EXIT_URL = (state, url) => {
  state.componentExitUrl.push(url);
}
